import useTranslation from "@/hooks/useTranslation";
import { NaviParams } from "@/interfaces/navi.interface";
import { Slider, Switch } from "antd";
import React from "react";
import styles from "./styles.module.less";

const { wrapper, flex, label, left, divider } = styles;

interface IProps {
  ifFilter: boolean;
  ifFilterMax: number;
  ifFilterMin: number;
  setSearchParams: (searchParams: Partial<NaviParams>) => void;
}

const Factor: React.FC<IProps> = ({
  ifFilter,
  ifFilterMax,
  ifFilterMin,
  setSearchParams,
}) => {
  const { t } = useTranslation("explore");

  const onChange = ([min, max]: [number, number]) => {
    setSearchParams({ ifFilterMin: min, ifFilterMax: max });
  };

  const toggleIfFilter = (checked: boolean) => {
    setSearchParams({ ifFilter: checked });
  };

  return (
    <div className={wrapper}>
      <div className={flex}>
        <div className={label}>{t("pubmed.sidebar.impact-factor")}</div>
        <div className={left}>
          <Switch checked={ifFilter} onChange={toggleIfFilter} />
        </div>
      </div>
      <div className={divider}>
        <Slider
          disabled={!ifFilter}
          marks={marker()}
          range
          value={[ifFilterMin, ifFilterMax]}
          max={41}
          min={0}
          // @ts-ignore
          onChange={onChange}
          tipFormatter={formatter}
        />
      </div>
    </div>
  );
};

export function formatter(value: number) {
  return `${value > 40 ? ">40" : value}`;
}

export function marker() {
  return {
    0: {
      style: {
        fontWeight: 500,
      },
      label: 0,
    },
    3: {
      style: {
        fontWeight: 500,
      },
      label: 3,
    },
    5: {
      style: {
        fontWeight: 500,
      },
      label: 5,
    },
    10: {
      style: {
        fontWeight: 500,
      },
      label: 10,
    },
    20: {
      style: {
        fontWeight: 500,
      },
      label: 20,
    },
    30: {
      style: {
        fontWeight: 500,
      },
      label: 30,
    },
    41: {
      style: {
        fontWeight: 500,
      },
      label: ">40",
    },
  };
}

export default Factor;
